import { cannabisBatchSlice } from '../slices/cannabisBatchSlice';

export default cannabisBatchSlice.reducer;
